import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'

import App from './App'
import './styles.css'
// Тема портала 55 — прежняя основа (решение 31.07.2026); остаётся для Home-плиток.
// Только переменные --t55-* и классы t55-*: селекторов styles.css файл не трогает.
import './theme55.css'
// Дизайн-система 2026 (решение владельца 01.08.2026: «Терминал» базой). Токены
// --t26-* + «мост» на 24 переменные styles.css, живущий за классом theme-2026.
import './theme2026.css'

// ── Тема до первого кадра ──
// Выбор темы («тёмная»/«светлая» вместо «за системой») лежит в localStorage под
// ключом cir-theme; styles.css читает его через data-theme на <html>. Атрибут
// ставим ЗДЕСЬ, до отрисовки React: если это делать в Layout, страница на миг
// вспыхивает системной темой и лишь потом перекрашивается. Пока переключателя
// в Layout нет, ключ никем не пишется и строки ниже ничего не меняют.
try {
  const т = localStorage.getItem('cir-theme')
  if (т === 'dark' || т === 'light') document.documentElement.dataset.theme = т
} catch {
  // приватный режим Safari бросает на localStorage — остаёмся «за системой»
}
// Включение дизайн-системы 2026 (мост theme2026.css). Откат — удалить эту строку;
// живая проверка — toggle('theme-2026') в консоли.
document.documentElement.classList.add('theme-2026')

const qc = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,   // вернулся в таб — данные освежились
      staleTime: 30_000,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={qc}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
